import React from 'react';
import { Clock, Heart, Compass } from 'lucide-react';
export function AwarenessCards() {
  const cards = [{
    icon: Clock,
    label: 'TRECUTUL',
    subtitle: 'RĂNI NEVINDECATE · TRAUME · TIPARE VECHI',
    body: 'Te surprinzi retrăind aceleași dureri, aceleași relații, aceleași rupturi? Traumele, pierderile, divorțul sau experiențele din copilărie pot rămâne active în subconștient și îți conduc deciziile fără să îți dai seama. Parcă faci pași înainte, dar ceva te trage mereu înapoi.'
  }, {
    icon: Heart,
    label: 'PREZENTUL',
    subtitle: 'CONFUZIE · EPUIZARE · LIPSĂ DE DIRECȚIE',
    body: 'În exterior funcționezi. În interior simți frică, nesiguranță, oboseală profundă și pierderea sensului. Nu mai știi ce vrei, ce să alegi, încotro să mergi. Deciziile mici devin copleșitoare, iar gândul că ești singură în toate astea te apasă tot mai mult.'
  }, {
    icon: Compass,
    label: 'VIITORUL',
    subtitle: 'TEAMĂ · BLOCAJ · NEÎNCREDERE',
    body: 'Îți dorești schimbare, dar nu știi de unde să începi. Ți-e teamă că viitorul va arăta la fel ca trecutul. Fără vindecare și claritate, visurile rămân doar intenții amânate, iar tu continui să aștepți momentul potrivit care nu mai vine niciodată.'
  }];
  return <section className="bg-blush py-24 md:py-32" data-id="element-55">
      <div className="max-w-[1180px] mx-auto px-6 space-y-16" data-id="element-56">
        <div className="text-center" data-id="element-57">
          <h2 className="font-serif text-4xl md:text-5xl font-medium text-cyan" data-id="element-58">
            Te regăsești în cel puțin una din aceste situații?
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-59">
          {cards.map((card, index) => {
          const Icon = card.icon;
          return <div key={index} className="bg-white rounded-2xl border border-cardBorder p-8 space-y-6" data-id="element-60">
                {/* Top accent bar */}
                <div className="w-full h-1 bg-magenta rounded-full" data-id="element-61"></div>

                {/* Icon */}
                <Icon className="w-12 h-12 text-magenta" strokeWidth={1.5} data-id="element-62" />

                <div className="space-y-2" data-id="element-63">
                  <h3 className="font-serif text-2xl font-medium text-navy" data-id="element-64">
                    {card.label}
                  </h3>
                  <p className="text-xs font-medium tracking-widest uppercase text-muted" data-id="element-65">
                    {card.subtitle}
                  </p>
                </div>

                {/* Body */}
                <p className="text-base leading-relaxed text-navy" data-id="element-66">
                  {card.body}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}